import React from 'react';
import circle1 from '../img/shape/circle1.png';
import dot from '../img/shape/Dot.png';
import blogImg1 from '../img/6.png'; 
import blogImg2 from '../img/7.png'; 
import blogBg from '../img/shape/blog-bg.png';

const BlogSection = () => {
  return (
    <div className="space-top space-extra-bottom blog-wrapper1 shape-mockup-wrap">
      {/* Background Shapes */}
      <div className="shape-mockup d-none d-xl-block spin z-index-negative" style={{ top: '-5%', left: '-5%' }}>
        <img src={circle1} alt="circle" />
      </div>
      <div className="shape-mockup d-none d-xl-block jump z-index-negative" style={{ bottom: '5%', right: '5%' }}>
        <img src={dot} alt="Dots" />
      </div>

      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-xxl-6 col-xl-7 col-lg-8 wow fadeInUp" data-wow-delay="0.3s">
            <div className="title-area">
              <span className="sec-subtitle">Platinum24 Cabs</span>
              <h2 className="sec-title h1">Reliable, Comfortable & Safe Rides — Anytime, Anywhere</h2>
            </div>
          </div>
        </div>

        {/* Blog Post 1 - Service Highlight */}
        <div className="blog-style4">
          <div className="blog-image">
            <img src={blogImg1} alt="Platinum24 Cabs Ride" />
            <div className="category-tag">
              <a href="#"><i className="fas fa-tag"></i> Service</a>
            </div>
          </div>
          <div className="blog-content" style={{ backgroundImage: `url(${blogBg})` }}>
            <a className="blog-date" href="/booking">
              <i className="far fa-calendar-alt"></i> Always Available
            </a>
            <h3 className="blog-title">
              <a href="/booking">Premium Cab Services with Professional Drivers</a>
            </h3>
            <p className="blog-text">
              Platinum24 Cabs offers 24/7 reliable transportation with well-maintained vehicles and
              trained drivers. Whether it’s an airport transfer, daily commute, or city tour — we’ve got you covered.
            </p>
            <a className="vs-btn style4" href="/booking">Book Now</a>
          </div>
        </div>

        {/* Blog Post 2 - Customer Experience */}
        <div className="blog-style4">
          <div className="blog-image">
            <img src={blogImg2} alt="Happy Customers" />
            {/* <div className="category-tag">
              <a href="#"><i className="fas fa-tag"></i> Experience</a>
            </div> */}
          </div>
          <div className="blog-content" style={{ backgroundImage: `url(${blogBg})` }}>
            <a className="blog-date" href="/booking">
              <i className="far fa-calendar-alt"></i> Trusted By Thousands
            </a>
            <h3 className="blog-title">
              <a href="/booking">Safe & Hassle-Free Rides Every Time You Travel</a>
            </h3>
            <p className="blog-text">
              Our customers love the punctuality, cleanliness, and courteous drivers. Join thousands of happy riders who trust Platinum24 Cabs for every journey.
            </p>
            <a className="vs-btn style4" href="/booking">Book Now</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogSection;
